import { render, staticRenderFns } from "./NewMulti.vue?vue&type=template&id=5d096390&scoped=true&"
import script from "./NewMulti.vue?vue&type=script&lang=js&"
export * from "./NewMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d096390",
  null
  
)

export default component.exports